import { useContext } from 'react'
import { FlashMessageContext } from 'creators/common/flashMessages/FlashMessageProvider'

function FlashMessagesContainer() {
  const { currentFlashMessage } = useContext(FlashMessageContext)
  return currentFlashMessage || null
}

export default FlashMessagesContainer
